import { AdminUserSessionContext } from '../../viewmodels/AdminViewModels';
import { AppState, UserSessionViewModelKey } from '../AppState';

export const useAdminUserSession = <T extends AdminUserSessionContext = AdminUserSessionContext>() => {
	return AppState[UserSessionViewModelKey] as T;
};
